import React from 'react';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import lang from '../../constants/Languages.js';
import propTypes from 'prop-types';
import {Field} from 'redux-form';
import {Link} from 'react-router-dom';

import DetailsDescResultsSelect from './DetailsDescResultsSelect.js';

const DetailsDescResultsForm = ({clang, filters, submitting, pristine, reset, handleSubmit, handleChange, initialValues, getSelectedFilterOptions}) => {
    const getLink = (options) => {
      const item = options.filter(option => option.selected)[0];

      if (!item || !item.type || !item.id) {
        return;
      }

      switch (item.type) {
        case 'event':
          return `/item/${item.type}/${item.id.replace(new RegExp("e_"), '')}`
        case 'event-series':
          return `/item/${item.type}/${item.id.replace(new RegExp("es_"), '')}`
        default:
          return `/item/${item.type}/${item.id}`
      }
    };

    const getType = (options) => {
      const item = options.filter(option => option.selected)[0];
      if (!item) {
        return;
      }
      return item.type;
    };

    return (
        <div className="results__details__form">
            <form onSubmit={handleSubmit}>
                    {filters.length > 0 && filters.map((filter, index) =>
                      <div className="results__details__form__content" key={index}>
                        <Field component={DetailsDescResultsSelect}
                            name={`${filter.name}`}
                            placeholder=""
                            onChange={(values) => handleChange(values, filter.name, filter.related)}
                            label={lang[clang].headings_details[filter.name]}
                            // disabled={filter.related === true && index > 0 && (!filters[0].options.filter(option => option.selected).length || filters[0].options.filter(option => option.selected)[0].id == "0")}
                            props={{
                                options: getSelectedFilterOptions(filter.options)
                            }} />
                        {getLink(filter.options) &&
                          <Link to={`${getLink(filter.options)}`} className="results__details__link">
                              {lang[clang].headings_details.go_to} {lang[clang].headings_details.go_to_dest[getType(filter.options)]}
                          </Link>}
                      </div>
                    )}
            </form>
        </div>
    );
};

DetailsDescResultsForm.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default connect(mapStateToProps)(reduxForm({
})(DetailsDescResultsForm));



// WEBPACK FOOTER //
// ./src/components/characteristics-details/DetailsDescResultsForm.js